import { Box, styled } from '@mui/material';

export const PreviousContributionCardStyled = styled(Box)({
  backgroundColor: "#F6F8F9",
  border: "1px solid #BBC1D0",
  padding: "24px",
  borderRadius: "4px",
  '@media (max-width: 743px)': {
    backgroundColor: "#FFFFFF",
    border: "none",
    padding: "24px 0px",
  }
});

export const TitleStyled = styled(Box)({
  fontWeight: "bold",
  fontSize: "16px"
});

export const DescriptionStyled = styled(Box)<{ isAnySelected: boolean }>(
  ({ isAnySelected }) => ({
    color: "#55575E",
    fontSize: "14px",
    '@media (max-width: 743px)': {
      display: isAnySelected ? 'none' : 'block'
    }
  })
);

export const RadioGroupStyled = styled(Box)({
  display: "flex",
  gap: "24px"
});

export const ContributionInputSectionStyled = styled(Box)({
  display: "flex",
  alignItems: "center"
});

export const InfoMessageStyled = styled(Box)({
  backgroundColor: "#DEE7FF",
  margin: "16px -24px -24px -24px",
  padding: "12px 20px"
});

export const InfoMessageTitleStyled = styled(Box)({
  fontWeight: "bold",
  fontSize: "14px"
});

export const InfoMessageDescriptionStyled = styled(Box)({
  fontSize: "12px"
});

export const ModalTitleStyled = styled(Box)({
  fontSize: "14px",
  fontWeight: 600,
  color: "#212935"
});

export const ModalDescriptionStyled = styled(Box)({
  fontSize: "14px",
  fontWeight: 400,
  color: "#212935",
  marginTop: "8px"
});